export default function VolumeCandle(overlay, ctx, layout, data, volumeRatio) {

    const green = data.raw[4] >= data.raw[1]
    const baseColor = green ? overlay.upColor : overlay.downColor

    // Volume candles: width proportional to volume, color stays solid
    // volumeRatio is 0..1 where 1 = highest volume in visible range
    let widthScale = 0.4 + (volumeRatio * 0.6) // 40% to 100% of normal width
    let w = Math.max(data.w * widthScale, 1)
    let hw = Math.max(Math.floor(w * 0.5), 1)
    let h = Math.abs(data.o - data.c)
    let max_h = data.c === data.o ? 1 : 2
    let x05 = Math.floor(data.x) - 0.5

    // Draw wick (always thin)
    ctx.strokeStyle = baseColor
    ctx.lineWidth = 1
    ctx.beginPath()
    ctx.moveTo(x05, Math.floor(data.h))
    ctx.lineTo(x05, Math.floor(data.l))
    ctx.stroke()

    // Draw body with volume-proportional width
    if (w > 1.5) {
        ctx.fillStyle = baseColor
        let s = green ? 1 : -1
        ctx.fillRect(
            Math.floor(data.x - hw - 1),
            data.c,
            Math.floor(hw * 2 + 1),
            s * Math.max(h, max_h)
        )
    } else {
        ctx.strokeStyle = baseColor
        ctx.beginPath()
        ctx.moveTo(x05, Math.floor(Math.min(data.o, data.c)))
        ctx.lineTo(x05, Math.floor(Math.max(data.o, data.c)) + (data.o === data.c ? 1 : 0))
        ctx.stroke()
    }
}
